import {React, useEffect} from "react";
import "./terms.css";
import InfoComponent from "../InfoComponent";
import { useLocation } from "react-router-dom";

const Terms = () => {
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 4);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);
  return (
    <>
    <div className="terms-heading">     <InfoComponent titleLg="TERMS AND CONDITIONS  " /></div>
 
      <div className="col-md-12 terms-content">
        <p>
          These <b> Digital Collectible Terms</b> (“Terms”) set forth the terms and
          conditions applicable to certain Digital Collectibles (as defined
          below) made available By <b>Coast Collectibles Limited </b>(“CCL”). By
          acquiring any non-fungible blockchain-based digital token (“NFT”)
          associated with CCL-Owned Content (as defined below) through the
          Website, A third party marketplace such as Opensea or by subsequently
          acquiring any such NFT from any previous owner of the NFT, you agree
          to be bound by these Terms.
        </p>
        <p>
         <b>1.</b> Each NFT made available by CCL is associated with certain physical
          items or digital works of authorship or other content, whether or not
          copyrighted or copyrightable, and regardless of the format in which
          any of the foregoing is made available (“Related Content”). Related
          Content is separate from the associated NFT, and is not sold or
          otherwise transferred to you. In case of digital products, the content
          is licensed to you as set forth in these Terms. A “Digital
          Collectible” consists of the applicable NFT and the license rights
          granted pursuant to these Terms for the Related Content. In case of an
          NFT which represents a physical product, the physical product will
          cease to exist once the NFT has been minted. CCL assumes full
          responsibility for ensuring the destruction of the physical asset and
          accepts no responsibility for subsequent listings of the same product
          by other sellers on physical marketplaces.
        </p>
        <p>
        <b>2.</b> These Terms apply only when all Related Content for a particular
          NFT is exclusively owned or controlled by CCL (“CCL-Owned Content”).
          In case any of the Related Content for that NFT or Digital Collectible
          is owned by a third party, different terms will apply and this will be
          explicitly mentioned in the contract.
        </p>
        <p>
        <b>3.</b> Subject to your compliance with these Terms, for as long as you own
          the applicable NFT, CCL grants you a limited, personal, non-exclusive,
          non-sublicensable, worldwide license to: (a) copy and modify the
          CCL-Owned Content (as modified, “Modified Content”) for
          non-commercial, personal use; and (b) display and perform the
          CCL-Owned Content and Modified Content for non- commercial, personal
          use.
        </p>
        <p>
        <b>4.</b> Should you wish to use the content for commercial use (the
          “Commercial Use License”), please reach out to us for licencing and
          commercial terms.
        </p>
        <p>
        <b>5.</b> Section 3 sets forth all of your license rights hereunder with
          respect to any CCL- Owned Content. There are no other license rights,
          whether express or implied, under any patent, trademark, trade secret
          or other intellectual property or proprietary right other than any
          copyright owned or controlled by CCL.
        </p>
        <p>
        <b>6.</b> CCL retains all right, title and interest in the CCL-Owned Content
          and all copyright or other intellectual property rights. Except for
          the license rights expressly granted in Section 3, above, you do not
          have and will not have any right, title or interest in the CCL-Owned
          Content which may include trade names, brands, logos, trademarks,
          names, likenesses, images or other personal characteristics of persons
          or characters (“Embedded IP”). All use of such Embedded IP, including
          any goodwill generated by such use, will inure to the benefit of CCL
          and its Affiliates. An “Affiliate” is any entity that controls, is
          controlled by or is under common control whether now or in the future,
          and where “control” means ownership of 50% or more of the shares or
          other ownership interest if an entity or the ability to direct the
          management or policies of an entity.
        </p>
        <p>
        <b>7.</b> You will own the copyright in any newly created works of authorship
          created by you as part of any Modified Content, subject to CCL’s
          ownership of the underlying CCL-Owned Content and any copyright or
          other intellectual property right therein. You will not assert or seek
          to register or obtain, any trademark or other intellectual or
          proprietary right in any CCL-Owned Content or Modified Content.
        </p>
        <p>
        <b>8.</b> You understand that CCL and its Affiliates will continue to further
          modify and develop on any CCL-Owned Content and may create works of
          authorship similar or identical to Modified Works created by you. On
          behalf of yourself and your heirs, successors and assigns, you
          irrevocably and perpetually covenant and agree not to file or assert
          before any court or other government tribunal or authority, any claim,
          counterclaim, demand, action, suit or other proceeding alleging or
          asserting direct or indirect infringement or misappropriation of any
          copyright or other intellectual property right that you may have in
          any Modified Work against (a) any of CCL, any Affiliate of CCL or any
          of their respective shareholders, directors, officers, employees,
          contractors, representatives, agents, licensees, distributors,
          resellers, or business partners, (b) any customers of any of the
          foregoing, or (c) any successor or assign of any of the foregoing.
        </p>
        <p>
        <b>9.</b> You will not (a) create, sell or attempt to create or sell,
          fractionalized interests in the NFT or the Digital Collectible, (b)
          separate, unlink or decouple the Content from the NFT with which it is
          associated to form the Digital Collectible, or (c) use any CCL-Owned
          Content or Modified Content to create, sell or attempt to create or
          sell any new cryptographic token.
        </p>
        <p>
        <b>10.</b> To the extent that you are not prohibited from doing so by any
          other terms or conditions applicable to a particular NFT or Digital
          Collectible, you may transfer the NFT to a third party, provided that
          the following conditions are met: (a) such transfer is conducted
          through a marketplace or other platform that cryptographically
          verifies that you are the actual owner of the applicable NFT; (b) such
          transfer must comply with (i) any applicable terms of the marketplace
          or other platform on which such sale or other transfer takes place and
          (ii) any applicable laws, regulations, regulatory guidance, and rules;
          (c) prior to such sale or other transfer, you must (i) inform the
          buyer that they will be subject to these terms and conditions and (ii)
          ensure that such buyer is provided with an opportunity to review these
          Terms; and (d) after such transfer, your right to display and perform
          the CCL-Owned Content and all other license rights under these Terms
          will immediately terminate
        </p>
        <p>
        <b>11.</b> Upon transfer of any NFT, in consideration of the transfer of the
          license rights set forth in these Terms, the ongoing hosting of any
          CCL-Owned Content and any other associated services, you will pay (or
          caused to be paid) to CCL a royalty fee in an amount calculated based
          on a percentage of the gross consideration. If the platform or service
          used to facilitate the transfer captures and pays the full amount of
          the Royalty Fee directly to CCL then you will have no obligation to
          pay any additional amounts. You will pay all transaction fees, payment
          transfer fees and taxes associated with the transfer and will not
          deduct any such amounts from the amount paid to CCL as Royalty. All
          amounts owed hereunder will be paid in US Dollars or in Ethereum and
          will be paid to the account or digital wallet designated by CCL.
        </p>
        <p>
        <b>12.</b> The digital collectible is intended for consumer enjoyment, use
          and consumption only. It is not a “security,” as defined under the
          capital gains manual of HMRC.
        </p>
        <p>
        <b>13.</b> You will comply with any NFT issuance or marketing policy on the
          CCL website.
        </p>
        <p>
        <b>14.</b> CCL will have no responsibility or liability, and you hereby waive
          and release any and all claims, arising out of or in connection with
          (a) any blockchain or related technology, (b) any digital wallet,
          MetaMask technology, similar technology or related service, (c) the
          transfer or loss of any NFT or the inability to demonstrate ownership
          or control of any NFT, (d) any marketplace or other platform for
          buying, selling or transferring any NFT other than the Website, (e)
          any platform or service provided by any third party or any technology
          related thereto, (f) any Modified Content or Additional Benefit
          provided by any third party, or any terms or conditions applicable to
          any such Modified Content or Additional Benefit, (g) any computer,
          server, network device or other hardware or any Internet service
          provider or other telecommunications service or hardware, or (h) any
          other service, equipment, technology or network or data transfer
          infrastructure not owned and controlled by us.
        </p>
        <p>
        <b>15.</b> You will indemnify and hold harmless, and at CCL’s request defend
          CCL and its Affiliates from and against any and all claims, demands,
          liabilities, damages, penalties, fines, taxes, costs and expenses
          (including without limitation reasonable attorneys’ fees and court
          costs) arising out of or in connection with (a) any breach of these
          Terms or unauthorized use of any CCL-Owned Content, (b) your ownership
          or transfer of any NFT, or (c) exercise of any license rights
          hereunder by you.
        </p>
        <p>
        <b>16.</b> CCL makes digital collectibles, NFTs and CCL-owned content, as
          well as any additional benefit that any of them or any third party may
          provide, available “as is”, “where is” and expressly disclaim any and
          all representations or warranties of any kind, express or implied,
          including, without limitation, any warranties of title,
          non-infringement, merchantability, or fitness for a particular purpose
          and any warranties arising from course of performance, course of
          dealing or usage in trade.
        </p>
        <p>
        <b>17.</b> In no event will CCL or its affiliates be liable for any indirect,
          incidental, consequential, or other non-direct damages of any kind or
          for any special, punitive or similar damages.
        </p>
        <p>
        <b>18.</b> In addition to any other rights and remedies to which CCL may be
          entitled under contract, at law or in equity, if you breach any of
          your obligations under these Terms, your right to display and perform
          the CCL-Owned Content and any and all other license rights that you
          may have under these Terms will immediately terminate without any
          requirement of notice. Upon termination of your license rights you
          will immediately cease all use of any CCL- Owned Content. We may
          disable the wallet functionality for the affected Content, prohibit
          any platform or service from retrieving or rendering any such Content
          in connection with the services they provide and take other steps to
          prevent unauthorized use of any Content. CCL will have no obligation
          or liability to you for any such actions and you will not interfere
          with, or seek to prevent, any such actions.
        </p>
        <p>
        <b>19.</b> These Terms supplement any additional terms and conditions in any
          information or materials provided with any CCL-Owned Content or
          Additional Benefit (“Additional Terms”). In the event of any conflict
          or inconsistency between these Terms and any Additional Terms, the
          Additional Terms will supersede and govern. These Terms and any
          Additional Terms constitute the entire agreement between you and CCL
          with respect to the subject matter hereof, and supersede any and all
          prior or contemporaneous written or oral agreements or understandings
          between you and CCL relating to the NFT, CCL-Owned Content or Digital
          Collectible.
        </p>
        <p>
        <b>20.</b> These Terms will be construed in accordance with the laws of
          United Kingdom as applied to contracts made and performed entirely
          therein, and without regard to conflicts of laws principles to the
          contrary.
        </p>
        <p>
        <b>21.</b> These Terms do not, and may not be construed to, create any
          partnership, joint venture or agency between you and CCL. If any
          provision of these Terms is found to be unlawful, void or for any
          reason unenforceable, that provision will be enforced to the maximum
          extent permitted by law and otherwise deemed severable from these
          Terms and will not affect the validity and enforceability of any
          remaining provisions. The failure of CCL to insist upon or enforce
          strict performance of any of the provisions of these Terms or to
          exercise any rights or remedies under these Terms will not be
          construed as a waiver or relinquishment to any extent of CCL's right
          to assert or rely upon any such provisions, rights or remedies in that
          or any other instance; rather, the same will be and remain in full
          force and effect. You may not assign, transfer or otherwise dispose of
          these Terms (including any rights or obligations hereunder), and any
          purported assignment, transfer or other disposition will be null and
          void.
        </p>
      </div>
   
    </>
  );
};
export default Terms;
